var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import get from 'lodash.get';
import React, { useEffect } from 'react';
import { useTracker } from '../../analytics/Analytics';
import { useShopConfig } from '../../hooks/useShopConfig';
import ProductConfigurationProvider from '../ProductConfigurationProvider/ProductConfigurationProvider';
import ProductVariationProvider from '../ProductVariationProvider/ProductVariationProvider';
import { StructuredProductData } from '../StructuredData';
import { useLocation } from 'react-router';
// TODO: We should remove this mock product as it only causes problems. The
// product page will try to render this product, which will never have all of
// the fields that you queried for. We should allow product to be undefined and
// handle it on the product page
const mockProduct = {
    articleNumber: '',
    images: [
        {
            sizes: []
        }
    ],
    variants: {
        options: [],
        values: []
    }
};
function getProduct(result) {
    const routeObject = get(result, 'data.route.object');
    const dataProduct = get(result, 'data.product');
    return {
        product: routeObject || dataProduct || mockProduct,
        cacheHit: !!(routeObject || dataProduct)
    };
}
const ProductRoute = (props) => {
    const { component: ProductPage } = props, rest = __rest(props, ["component"]);
    const { product, cacheHit } = getProduct(props.result);
    const { structuredData } = useShopConfig();
    const location = useLocation();
    const track = useTracker();
    const disableStructuredProductData = structuredData
        ? !!structuredData.disableDefaultProductData
        : false;
    useEffect(() => {
        var _a;
        cacheHit &&
            track(trackProductEvent({
                action: 'view',
                product,
                list: (_a = location.state) === null || _a === void 0 ? void 0 : _a.list
            }));
    }, [cacheHit, location.state, product, track]);
    return (React.createElement(React.Fragment, null,
        cacheHit && (React.createElement(React.Fragment, null, !disableStructuredProductData && (React.createElement(StructuredProductData, { product: product })))),
        React.createElement(ConditionalProviders, { product: product },
            React.createElement(ProductConfigurationProvider, { product: product },
                React.createElement(ProductPage, Object.assign({}, rest, { product: product, cacheHit: cacheHit }))))));
};
export default ProductRoute;
function ConditionalProviders({ product, children }) {
    const { deprecations: { useOldProductVariants } } = useShopConfig();
    return useOldProductVariants ? (React.createElement(ProductVariationProvider, { product: product }, children)) : (React.createElement(React.Fragment, null, children));
}
//# sourceMappingURL=ProductRoute.js.map